import { getLocalApiUrl } from '../../../config/api'

export function brandingDraftFromTenant(t) {
  return {
    logoUrl: t.logo_url || '',
    brandmarkUrl: t.brandmark_url || '',
    primaryColor: t.primary_color || '',
    secondaryColor: t.secondary_color || '',
    highlightColor: t.highlight_color || '',
  }
}

export function brandingImageSrc(url, groupId, kind) {
  if (!url || !String(url).trim()) return ''
  const u = String(url).trim()
  if (u.startsWith('https://') && u.includes('blob.core.windows.net')) {
    if (groupId && kind) {
      return getLocalApiUrl(`/api/admin/tenants/${encodeURIComponent(groupId)}/branding/preview?kind=${encodeURIComponent(kind)}`)
    }
    return u
  }
  if (u.startsWith('http://') || u.startsWith('https://')) return u
  const pathOnly = u.startsWith('/') ? u : `/${u}`
  return getLocalApiUrl(pathOnly)
}

export function DbStatusBadge({ tenant }) {
  if (!tenant.db_name) {
    return (
      <span className="inline-flex items-center gap-1 rounded-full bg-gray-100 px-2.5 py-0.5 text-xs font-medium text-gray-600">
        shared
      </span>
    )
  }
  const map = {
    ready: 'bg-emerald-50 text-emerald-700',
    migrating: 'bg-amber-50 text-amber-700',
    error: 'bg-red-50 text-red-700',
    pending: 'bg-blue-50 text-blue-600',
  }
  const label = tenant.db_status || 'pending'
  return (
    <span className={`inline-flex rounded-full px-2.5 py-0.5 text-xs font-medium ${map[label] || map.pending}`}>
      {label}
    </span>
  )
}

export const TENANT_TABS = [
  { id: 'overview', label: 'Overview' },
  { id: 'devices', label: 'Devices' },
  { id: 'mobile', label: 'Mobile' },
  { id: 'psg-gateway', label: 'PSG Gateway' },
  { id: 'printers', label: 'Printers' },
  { id: 'billable-usage', label: 'Billable usage' },
  { id: 'storage', label: 'Storage' },
  { id: 'daily-data', label: 'Daily Data' },
  { id: 'branding', label: 'Branding' },
  { id: 'profilesafe', label: 'ProfileSafe' },
  { id: 'password', label: 'Password' },
]

export const TENANT_WIDE_TABS = new Set(['devices', 'billable-usage', 'storage'])
